import script from "./CollapsiblePropertyKypScore.vue?vue&type=script&setup=true&lang=js"
export * from "./CollapsiblePropertyKypScore.vue?vue&type=script&setup=true&lang=js"

import "./CollapsiblePropertyKypScore.vue?vue&type=style&index=0&id=1ae7a526&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ae7a526"]])

export default __exports__